import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-checkmark',
  standalone: true,
  templateUrl: '../../assets/checkmark.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamCheckmarkIcon {}
